import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-item', 'REMOVE_SHORTCUT', 'Pašalinti');
